// ALGOLIA FILTER
document.addEventListener('DOMContentLoaded', function () {
    const filterBtn = document.getElementById('js-filterButton');
    const algoliaFilter = document.getElementById('tag-filterColumn');
    const algoliaFilterClose = document.getElementById('js-aisResetFilterResults');
    const showFilterClose = document.getElementById('js-aisShowFilterResults');
    const closeFilterBtn = document.getElementById('js-closeFilterMenu');

    const toggleAlgoliaMenu = () => {
        algoliaFilter.classList.toggle('show');
        document.body.classList.toggle('tag-no-scroll');
    };

    filterBtn.addEventListener('click', toggleAlgoliaMenu);
    algoliaFilterClose.addEventListener('click', toggleAlgoliaMenu);
    showFilterClose.addEventListener('click', toggleAlgoliaMenu);
    closeFilterBtn.addEventListener('click', toggleAlgoliaMenu);
});